import { z } from "zod";
import { baseHeaderSchema } from "./base-definition";

const dateSubtypeSchema = z.enum(["date", "time", "datetime"]);

export const dateSchema = baseHeaderSchema.extend({
  type: z.literal("date"),
  placeholder: z.string().optional(),
  subtype: dateSubtypeSchema,
  defaultValue: z.preprocess((val) => {
    if (val === "" || val === undefined || val === null) return undefined;
    if (typeof val === "number") return val;
    if (typeof val === "string") {
      const parsed = Number(val);
      return Number.isNaN(parsed) ? val : parsed;
    }
    return val;
  }, z.number().optional()),
  required: z.boolean().optional().default(false),
});

export type DateType = z.infer<typeof dateSchema>;
